import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPen,
  faCheck,
  faChevronCircleRight,
} from '@fortawesome/free-solid-svg-icons';

import Util from 'service/util';
import ContactList from './ContactList';


function getWeekday(s)
{
  return [s.weekday1, s.weekday2, s.weekday3]
    .map(Util.WeekdayName)
    .filter(x => x)
    .join(' / ');
}

class VehicleRow extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = { selected: false };
  }

  selectLicense(e, license)
  {
    if (this.props.onSelectLicense)
    {
      e.preventDefault();
      e.stopPropagation();
      this.props.onSelectLicense(license);
    }
  }

  render()
  {
    let v = this.props.vehicle;
    let c = this.props.customer;
    let s = this.props.vehicle.activeService || this.props.vehicle.recentService;

    let isActive = !!this.props.vehicle.activeService;
    let isSrvd   = !!this.props.vehicle.recentService;

    return (
      <label className={'table-row'+ (this.state.selected?' selected':'')}>
        <div className="col-cust-sel">
          <input type="checkbox" checked={this.state.selected} onChange={ e=>this.setState({selected: e.target.checked})} />
        </div>
        <div className="col-cust-company">
          { Util.getCompanyName(s?.company) }
        </div>
        <div className="col-cust-license">
          <span className="license" onClick={e=> this.selectLicense(e, v.cd_license) }>
            { v.cd_license }
          </span>
        </div>
        <div className="col-cust-owner dg-info">
          <div className="owner-name" title={c.display_name}>{ c.display_name }</div>
          <div className="vh-info-frame">
            <div className="vh-info">
              <label>
                <strong>狀態</strong>
                <div>{ (isActive && '現有客戶') || (isSrvd && '非服務中客戶') || 'N/A' }</div>
              </label>
              <label>
                <strong>地點</strong>
                {!!s && <>
                  <div>
                    {[`${s.srv_dis}${s.srv_loc}`,Util.getLocationName(s)].join(' - ')}
                  </div>
                  <div>
                    {[s.srv_floor.trim()||null, s.srv_psn.trim()||null].filter(x => x).join(', ')}
                  </div>
                </>}
              </label>
              { !!s && s.srv_plan !== 'A' &&
                <label>
                  <strong>服務日</strong>
                  <div>{ getWeekday(s) }</div>
                </label>
              }
              <label>
                <strong>車款</strong>
                <div>{ `${v.color} ${v.brand} ${v.model}`.trim() }</div>
              </label>
              <label>
                <strong>細項</strong>
                <div>
                  { !c.is_mobill      ?'':<span><FontAwesomeIcon icon={faCheck}/>月結</span> }
                  { !c.is_rtn_envelope?'':<span><FontAwesomeIcon icon={faCheck}/>回郵信封</span> }
                  { !c.is_print_bill  ?'':<span><FontAwesomeIcon icon={faCheck}/>印收費單</span> }
                </div>
              </label>
              <label>
                <strong>備註</strong>
                <div className="remarks">{ c.remarks }</div>
              </label>
              <label className="contact-list">
                <strong>聯絡方法</strong>
                <ContactList contacts={ c.contacts } />
              </label>
            </div>
          </div>
        </div>
        <div className="col-cust-location">{ s?.loc_key }</div>
        <div className="col-cust-service-plan">{ s?.srv_plan }</div>
        <div className="col-cust-vehicle-type">{ v?.vh_type }</div>
        <div className="col-cust-service-rotation">{ s?.rotation }</div>
        <div className="col-cust-service-fee">{ s?.fee && '$'+Util.nf(s?.fee) }</div>
        <div className="col-cust-service-exfee">{ s?.extra_fee && '$'+Util.nf(s?.extra_fee) }</div>
        <div className="col-cust-worker-name" title={s?.worker_code}>{ s?.worker_name }</div>
        <div className="col-cust-create-date">{ Util.ShortDate(c.create_dtm) }</div>
        <div className="col-cust-mod-date" title={ Util.FullDate(c.mod_dtm) }>
          { Util.ShortDate(c.mod_dtm) }
        </div>
        <div className="col-cust-mod-by">{ c.mod_by }</div>
        <div className="col-cust-btn-grp">
          <a className="btn-edit" href="#" title="修改" onClick={e=>this.props.showModal(v,c)}>
            <FontAwesomeIcon icon={faPen} />
          </a>
          <a className="btn-nav" href={`/op/services/${v.cd_license}/${c.id}`} title="前往收款">
            <FontAwesomeIcon icon={faChevronCircleRight} />
          </a>
        </div>
      </label>
    );
  }
}

export default VehicleRow;